// import Alert from 'bootstrap/js/dist/alert';
// import Button from 'bootstrap/js/dist/button';
// import Carousel from 'bootstrap/js/dist/carousel';
// eslint-disable-next-line
import Collapse from 'bootstrap/js/dist/collapse';
// eslint-disable-next-line
import Dropdown from 'bootstrap/js/dist/dropdown';
import Modal from 'bootstrap/js/dist/modal';
// import Offcanvas from 'bootstrap/js/dist/offcanvas';
// import Popover from 'bootstrap/js/dist/popover';
// import Scrollspy from 'bootstrap/js/dist/scrollspy';
// import Tab from 'bootstrap/js/dist/tab';
// import Toast from 'bootstrap/js/dist/toast';
import Tooltip from 'bootstrap/js/dist/tooltip';
import 'sharer.js';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { CountUp } from 'countup.js';
import isotopeInit from './isotope-init';

// const Rellax = require('rellax');

export default function uiComponentsInit() {
  isotopeInit();
  Swiper.use([Navigation, Pagination, Autoplay]);
  window.Sharer.init();
  document.querySelectorAll('[data-countup]').forEach((el) => {
    const observer = new IntersectionObserver(
      // eslint-disable-next-line no-shadow
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            new CountUp(
              entry.target,
              entry.target.getAttribute('data-countup')
            ).start();

            observer.unobserve(entry.target);
          }
        });
      }
    );
    observer.observe(el);
  });

  window.cookieconsent.initialise({
    palette: {
      popup: {
        background: '#f1f1f1',
      },
      button: {
        background: '#f29472',
        text: '#ffffff',
      },
    },
    content: {
      href: cookieConsent.href,
      message: cookieConsent.disclaimer,
      dismiss: cookieConsent.allow,
      link: cookieConsent.learn,
    },
    position: 'bottom-left',
  });

  // BS5 modals
  [].slice
    .call(document.querySelectorAll('[data-bs-toggle="modal"]'))
    .map((modalTriggerEl) => new Modal(modalTriggerEl));

  // BS5 tooltips
  [].slice
    .call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    .map((tooltipTriggerEl) => new Tooltip(tooltipTriggerEl));

  // BS5 Dropdowns
  // [].slice
  //   .call(document.querySelectorAll('[data-bs-toggle="dropdown"]'))
  //   .map((dropdownToggleEl) => {
  //     console.log(dropdownToggleEl);
  //     return new Dropdown(dropdownToggleEl);
  //   });
  // BS5 collapse
  // [].slice
  //   .call(document.querySelectorAll('.collapse'))
  //   .map((collapseEl) => new Collapse(collapseEl));

  // $(".flatpickr").flatpickr();
  // $(".my-select").selectpicker();
  // $("input[type='number']").inputSpinner();

  // eslint-disable-next-line no-unused-vars
  // const rellax = new Rellax('.rellax'); // eslint-disable-next-line func-names
  $('.btn-spinner').on('click', function () {
    const $this = $(this);
    // console.log($(this));
    $this
      .addClass('loading')
      .append(
        "<span class='spinner-border' role='status' aria-hidden='true'></span>"
      );

    // eslint-disable-next-line func-names
    setTimeout(() => {
      $this.removeClass('loading');
      $('.spinner-border').remove();
    }, 4000);
  });

  // const rangeSlider = document.getElementById('rs-range-line');
  // const rangeBullet = document.getElementById('rs-bullet');

  // function showSliderValue() {
  //   rangeBullet.innerHTML = rangeSlider.value;
  //   const bulletPosition = rangeSlider.value / rangeSlider.max;
  //   rangeBullet.style.left = `${bulletPosition * 578}px`;
  // }

  // if (rangeSlider !== null) {
  //   rangeSlider.addEventListener('input', showSliderValue, false);
  // }

  // // Contact form 7 init
  // if (window.wpcf7 && typeof wpcf7.init === 'function') {
  //   document.querySelectorAll('.wpcf7 > form').forEach((e) => {
  //     wpcf7.init(e);
  //   });
  // }

  // // Contact form 7 Conditional fields init
  // if (window.wpcf7cf && typeof wpcf7cf.initForm === 'function') {
  //   wpcf7cf.initForm(jQuery('.wpcf7-form'));
  // }

  const swiperCommons = {
    resistanceRatio: 0,
    speed: 200,
    grabCursor: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
    },
    autoplay: {
      delay: 7000,
      pauseOnMouseEnter: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      // when window width is >= 0px
      0: {
        slidesPerView: 1,
      },
      // when window width is >= 576px
      768: {
        slidesPerView: 1,
      },
      // when window width is >= 768px
      901: {
        slidesPerView: 'auto',
      },
      // when window width is >= 991px
      1201: {
        slidesPerView: 'auto',
      },
      // when window width is >= 1201px
      1501: {
        slidesPerView: 'auto',
      },
    },
    a11y: {
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
    },
  };

  // eslint-disable-next-line no-unused-vars
  const swiperPosts = new Swiper('.swiper-post-container', {
    ...swiperCommons,
    ...{
      slidesPerView: 4,
      loop: false,
    },
  });

  // eslint-disable-next-line no-unused-vars
  const swiperTestimonials = new Swiper('.swiper-testimonials-container', {
    ...swiperCommons,
    ...{
      slidesPerView: 3,
      loop: true,
    },
  });

  // $(".single-slider").jRange({
  //   from: 0,
  //   to: 200,
  //   step: 5,
  //   scale: [0, 100, 200],
  //   format: "%s",
  //   width: 300,
  //   showLabels: true,
  //   snap: true
  // });
  // $(".range-slider").jRange({
  //   from: 0,
  //   to: 200,
  //   step: 5,
  //   scale: [0, 100, 200],
  //   format: "%s",
  //   width: 300,
  //   showLabels: true,
  //   isRange: true
  // });

  if (Calendly) {
    $('.calendly-inline-widget').each(function () {
      // if the widget wasn't initialized already, initialize it
      if (!$(this).data('processed')) {
        Calendly.initInlineWidget({
          url: $(this).data('url'),
          parentElement: $(this),
        });
      }
    });
  }
}
